export default {
  painManagement: {
    title: '¿En qué área sientes dolor?',
    validation: {
      required: 'Por favor selecciona una opción',
    },
    painOptions: {
      neck: 'Dolor de cuello',
      lowerBack: 'Dolor de espalda baja',
      both: 'Dolor de cuello y espalda baja',
      none: 'No dolor en la espalda o cuello',
    },
    submit: 'Enviar',
  },
};
